const aboutus = {
    init () {
        aboutus.modalVideo();
        aboutus.scrollTo();
        aboutus.ourStorySlider();
        aboutus.contentSkip();
    },

    modalVideo () {
        const $modalAboutUs = $('#modal__about-us');

        $modalAboutUs.on('shown.bs.modal', (e) => {
            const src = $(e.relatedTarget).attr('data-video');
            $('#modal__about-us .thumb-pop-main').attr('src', src);
        });

        $modalAboutUs.on('hidden.bs.modal', (e) => {
            $('#modal__about-us .thumb-pop-main').attr('src', '');
        });
    },

    scrollTo () {
        $('.about-us__anchors a').on('click', function (e) {
            e.preventDefault();

            const offset = $($(this).attr('href')).offset().top;

            $('html, body').animate(
                {
                    scrollTop: offset,
                },
                1000
            );
        });
    },

    ourStorySlider () {
        const $ourStorySlider = $('.slick-slider.slick-slider__our-story');

        if ($ourStorySlider.length > 0) {
            const $dots = $('.slick-slider.slick-slider__our-story .slick-dots');
            const markup = "<li class='play-pause'><span></span></li>";

            $dots.append(markup);

            $('.slick-slider.slick-slider__our-story .play-pause').on('click', function (e) {
                e.preventDefault();

                const $this = $(this);

                if ($this.hasClass('show-play')) {
                    $this.removeClass('show-play');
                    $ourStorySlider.slick('slickPlay');
                } else {
                    $this.addClass('show-play');
                    $ourStorySlider.slick('slickPause');
                }
            });
        }
    },

    contentSkip () {
        $(document).on('click', '.page-template-template-aboutus .skip-navigation', (e) => {
            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: $('.about-us__intro').offset().top - 100,
                },
                1000
            );
        });
    },
};

$(document).ready(() => {
    if (Electro.DEBUG) {
        console.log('aboutus.init');
    }
    aboutus.init();
});
